// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5df8146a","453":"5539a22d","732":"761c7650"}[chunkId] + ".chunk.js";
};